<template>
  <div>
    <b-card>
      <c-table
        @onPageIndexChanged="onPageIndexChanged"
        :table-data="result"
        :loading="loading"
        :fields="fields"
        :striped="true"
        :export-enabled="false"
        tableName="auditTable"
      >
      </c-table>
    </b-card>
  </div>
</template>
<script>
import cTable from "./base/Table.vue";
import eventbus from "../eventBus";
import auditService from "../services/Configuration/auditService";
export default {
  name: "audit-list",
  inheritAttrs: false,
  components: {
    cTable
  },
  props: {
    table: {
      type: String
    },
    primaryKey: {
      type: String
    }
  },
  data: function() {
    return {
      loading: false,
      result: this.getEmptyResult(),
      fields: [
        { key: "id", label: "#", sortable: false },
        { key: "dateTime", label: "Data", sortable: false },
        { key: "userName", label: "Usuario", sortable: false },
        { key: "userRole", label: "Perfil", sortable: false },
        { key: "deviceAuditingAddInfo", label: "", sortable: false },
        { key: 'showDeviceAuditingDetail', label: '' }
      ]
    };
  },
  created() {
    this.fetchData(1);
  },
  methods: {
    getEmptyResult() {
      return {
        pageIndex: 1,
        pageCount: 0,
        tableCount: 0,
        disablePaging: false,
        data: []
      };
    },
    fetchData(page) {
      const self = this;
      this.showLoading();
      auditService.findAll(this.table, this.primaryKey, page).then(
        response => {
          self.$data.result =
            response.status == 204 ? self.getEmptyResult() : response.data;
          self.hideLoading();
        },
        () => {
          self.hideLoading();
        }
      );
    },
    showLoading() {
      this.loading = true;
      eventbus.$emit("ui-action:loading", true);
    },
    hideLoading() {
      this.loading = false;
      eventbus.$emit("ui-action:loading", false);
    },
    onPageIndexChanged(p, tableName) {
      this.fetchData(p);
    }
  }
};
</script>